/** Reagent/consumable inventory scoped to a lab — backs /lab/inventory/... */
import { fetchApi } from '../client';

export const labInventoryModule = {
  list: (labId?: string) =>
    fetchApi<any[]>(`/api/lab/inventory${labId ? `?labId=${labId}` : ''}`),

  get: (id: string) => fetchApi<any>(`/api/lab/inventory/${id}`),

  create: (data: any) =>
    fetchApi<any>('/api/lab/inventory', { method: 'POST', body: JSON.stringify(data) }),

  update: (id: string, data: any) =>
    fetchApi<any>(`/api/lab/inventory/${id}`, { method: 'PUT', body: JSON.stringify(data) }),

  /** The clinic's active lab test catalogue (own + global tests) — what an item can be linked to. */
  catalogueTests: () =>
    fetchApi<Array<{ id: string; testName: string; testCode?: string }>>('/api/lab-tests/active'),

  delete: (id: string) =>
    fetchApi<void>(`/api/lab/inventory/${id}`, { method: 'DELETE' }),
};
